var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "gantt-elastic",
      staticStyle: { width: "100%" },
      attrs: { tabindex: "-1" },
      on: {
        keydown: _vm.onKeyDown,
        keyup: _vm.onKeyUp,
        mousewheel: _vm.onMousewheel,
      },
    },
    [
      _vm._t("header"),
      _vm._v(" "),
      _c("main-view", { ref: "mainView" }),
      _vm._v(" "),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }